// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"286":"0a053f3c","965":"0a053f3c"}[chunkId] + ".chunk.css";
};